import React, { useEffect, useState } from "react";
import "./PrivateGigButton.css";
import { useSelector } from "react-redux";

const PrivateGigButton = ({ ButtonSelected, setButtonSelected }) => {
    const jobdetails = useSelector(
        (state) => state.getJobDetailReducer.jobdetails
    );
    useEffect(() => {
        if (jobdetails?.length > 0){
            setButtonSelected(jobdetails[0]?.isPrivate)
        }
    }, [jobdetails])
    return (
        <div className="Gig-private-cantiner">
            <div
                onClick={() => setButtonSelected(false)}
                className={`Gig-Public-Button ${ButtonSelected == false ? "OnGig-Button-Select" : "OnGig-Button-NotSelect"
                    }`}
            >
                Public
            </div>
            <div
                onClick={() => setButtonSelected(true)}
                className={`Gig-Private-Button ${ButtonSelected == true ? "OnGig-Button-Select" : "OnGig-Button-NotSelect"
                    }`}
            >
                Private
            </div>
        </div>
    );
};

export default PrivateGigButton;
